import { Input, Modal, Form, Button } from "antd";
import axios from "axios";
import React, { useState } from "react";
import MainButtonComp from "../../../commons/Buttons/MainButtonComp";
import DragUpload from "../../../commons/DragUpload/DragUpload";
import { Error, Success } from "../../../commons/Messages/Messages";
import "./ServiceProviders.css";
import PasswordField from "../../../commons/PasswordField";

import { useTranslation } from "react-i18next";
const AddServiceProviders = ({ updateParent }) => {
  const { t } = useTranslation("dashboard");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const onSubmit = async values => {
    if (values.picture) {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/service-providers/signup`,
          values,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        );
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
          updateParent();
          handleCancel();
        } else {
          Error(res.data.errorMessage);
        }
      } catch (err) {
        Error(err.message);
      }
    } else {
      Error(t("Picture is required"));
    }
  };

  return (
    <div className="AddServiceProviders">
      <MainButtonComp text="Add Service Provider" addBtn onClick={showModal} />
      <Modal
        destroyOnClose
        title={t("Add Service Provider")}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            {t("Cancel")}
          </Button>,
          <Button key="submit" type="primary" htmlType="submit" form="admin-add-service-provider">
            {t("Submit")}
          </Button>
        ]}
        width={640}
      >
        <Form
          id="admin-add-service-provider"
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          initialValues={{
            picture: {},
            firstName: "",
            lastName: "",
            username: "",
            email: "",
            password: "",
            confirm: "",
            serviceProviderId: "",
            phone: "",
            companyName: ""
          }}
        >
          <Form.Item
            label={t("Picture")}
            name="picture"
            rules={[{ required: true, message: t("Picture is required") }]}
          >
            <DragUpload
              noMultiple
              updateFiles={val => form.setFieldValue("picture", val[0]?.response)}
            />
          </Form.Item>

          <Form.Item
            label={t("First Name")}
            name="firstName"
            rules={[{ required: true, message: t("First Name is required") }]}
          >
            <Input autoComplete="off" />
          </Form.Item>

          <Form.Item label={t("Last Name")} name="lastName">
            <Input autoComplete="off" />
          </Form.Item>

          <Form.Item
            label={t("Username")}
            name="username"
            rules={[{ required: true, message: t("Username is required") }]}
          >
            <Input autoComplete="off" autoCapitalize="none" spellCheck={false} />
          </Form.Item>

          <Form.Item
            label={t("Email")}
            name="email"
            rules={[
              { required: true, message: t("Email is required") },
              { type: "email", message: t("Please enter a valid email") }
            ]}
          >
            <Input type="email" inputMode="email" autoComplete="off" />
          </Form.Item>

          <PasswordField label={t("Password")} name="password" />

          <Form.Item
            label={t("Confirm Password")}
            name="confirm"
            dependencies={["password"]}
            rules={[
              { required: true, message: t("Please confirm your password") },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t("passwordsDntMatch")));
                }
              })
            ]}
          >
            <Input.Password autoComplete="new-password" />
          </Form.Item>

          <Form.Item
            label={t("Service Provider ID")}
            name="serviceProviderId"
            rules={[{ required: true, message: t("Service Provider ID is required") }]}
          >
            <Input />
          </Form.Item>

          <Form.Item label={t("Phone")} name="phone">
            <Input type="tel" inputMode="tel" autoComplete="off" />
          </Form.Item>

          <Form.Item label={t("Company Name")} name="companyName">
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default AddServiceProviders;
